import { render, staticRenderFns } from "./Courseinformation.vue?vue&type=template&id=172f2597&scoped=true"
import script from "./Courseinformation.vue?vue&type=script&lang=js"
export * from "./Courseinformation.vue?vue&type=script&lang=js"
import style0 from "./Courseinformation.vue?vue&type=style&index=0&id=172f2597&prod&scoped=true&lang=css"
import style1 from "./Courseinformation.vue?vue&type=style&index=1&id=172f2597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f2597",
  null
  
)

export default component.exports